import { Checkbox } from "antd";
import { useEffect, useState } from "react";

import * as Styled from "./styles";
import { CheckboxGroupFieldProps } from "./types";

const CheckboxGroupField = <
  TOption extends Record<TValueProp | TLabelProp, string | number>,
  TValueProp extends string,
  TLabelProp extends string
>({
  options,
  valueProp,
  labelProp,
  value,
  onChange,
}: CheckboxGroupFieldProps<TOption, TValueProp, TLabelProp>): JSX.Element => {
  const [checked, setChecked] = useState<Record<string | number, TOption>>({});

  useEffect(() => {
    setChecked(
      value?.reduce(
        (newChecked, option) => ({
          ...newChecked,
          [option[valueProp]]: option,
        }),
        {}
      ) || {}
    );
  }, [value, valueProp]);

  return (
    <Styled.CheckboxGroupField>
      {options.map((option) => (
        <Checkbox
          key={option[valueProp]}
          checked={!!checked[option[valueProp]]}
          onChange={({ target }) => {
            const newChecked = {
              ...checked,
            };

            if (target.checked) {
              newChecked[option[valueProp]] = option;
            } else {
              delete newChecked[option[valueProp]];
            }

            setChecked(newChecked);
            onChange?.(Object.values(newChecked));
          }}
        >
          {option[labelProp]}
        </Checkbox>
      ))}
    </Styled.CheckboxGroupField>
  );
};

export default CheckboxGroupField;
